import get from 'lodash/get'

export const parseNodeContent = (node, accumulator) => {
  if (node === undefined) return

  if (node.data && get(node.data, 'target.sys.type') === 'Asset') {
    accumulator.push(get(node.data, 'target.fields.file.url'))
  }

  if (node.content && node.content.length > 0) {
    node.content.forEach(node => parseNodeContent(node, accumulator))
  }
}
